import { useState, useEffect, useMemo } from 'react';

import { getLogsRegistro } from '../../services/logs/logsAcoesService';
import { formatDate, formataNomeMeioSiglas } from '../../utils/functions';

export const useLogData = (
  entity: string,
  id: number,
  refreshTriggerLog: number,
) => {
  const [logEntries, setLogEntries] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      if (entity && id > 0) {
        try {
          const registros = await getLogsRegistro(entity, id);
          setLogEntries(registros);
        } catch (error) {
          console.error('Erro ao obter dados de log:', error);
          setLogEntries([]); // Limpa em caso de erro
        }
      }
    };

    fetchData();
  }, [entity, id, refreshTriggerLog]);

  const tableData = useMemo(
    () =>
      logEntries.map((item, index) => ({
        id: item.id ?? `${entity}-${id}-${index}`,
        'Data/Hora': formatDate(item.dataAcao),
        Usuário: formataNomeMeioSiglas(item.nomeCompleto),
        Interface: item.interfaceSisAf,
        Registro: item.registroId ?? '',
        Ação: item.tipoAcao,
        Detalhamento: item.detalhamento,
        Alterações: item.alteracoes,
      })),
    [logEntries],
  );

  return { logEntries, tableData };
};
